import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {Puzzle} from './puzzle.js';
import {GameFlowController} from './game-flow-controller.js';
import {Analytics, AnalyticsEvent} from '../classes/Analytics.js';

export enum PauseUnpauseAction {
    Pause,
    Unpause,
}

export class PauseUnpause extends Component {
    static TypeName = 'pause-unpause';

    // Singleton
    private static _instance: PauseUnpause;
    static get instance(): PauseUnpause {
        return PauseUnpause._instance;
    }

    init() {
        if (PauseUnpause._instance) {
            console.error('There can only be one instance of PauseUnpause Component');
        }
        PauseUnpause._instance = this;
    }

    onActivate(): void {
        document.addEventListener('visibilitychange', () => this._visibilityChange);
        window.addEventListener('blur', this._onBlur);
    }

    onDeactivate(): void {
        document.removeEventListener('visibilitychange', this._visibilityChange);
        window.removeEventListener('blur', this._onBlur);
    }

    start() {}

    update(dt: number) {}

    onClick(action: PauseUnpauseAction) {
        if (
            Puzzle.instance.gameInProgress &&
            !GameFlowController.instance.tutorialRunning &&
            GameFlowController.instance.canChangeMenu
        ) {
            const gameFlow = GameFlowController.instance;
            if (action == PauseUnpauseAction.Pause && !gameFlow.isPauseShowing()) {
                Analytics.StopTimedEvent(AnalyticsEvent.ShowGame);
                gameFlow.goToPauseMenu();
            } else if (action == PauseUnpauseAction.Unpause && gameFlow.isPauseShowing()) {
                Analytics.StartTimedEvent(AnalyticsEvent.ShowGame);
                gameFlow.closePauseMenu();
            }
        }
    }

    _visibilityChange = () => {
        this._autoPause(!document.hidden);
    };

    _onBlur = () => {
        this._autoPause(true);
    };

    _autoPause = (pause: boolean) => {
        const gameFlow = GameFlowController.instance;
        if (
            pause &&
            !gameFlow.isPauseShowing() &&
            Puzzle.instance.gameInProgress &&
            !gameFlow.tutorialRunning &&
            //!gameFlow.transition.TransitionInProgress &&
            !gameFlow.popupShowing
        ) {
            this.onClick(PauseUnpauseAction.Pause);
        }
    };
}
